import React, { useContext, useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import AuthContext from '../functions/AuthContext';
import '../styles/LoginPage.css';
import LogoPrincipal from '../components/logos';
import { useToast } from '../components/ToastProvider';
import '../styles/Common.css';
import { ReactComponent as IconUser } from "../assets/icons/icon-user.svg";
import { ReactComponent as IconLock } from "../assets/icons/icon-lock.svg";

const LoginPage = () => {
  const { login } = useContext(AuthContext);
  const navigate   = useNavigate();
  const location   = useLocation();

  const [username, setUsername]       = useState('');
  const [password, setPassword]       = useState('');
  // Toast para notificaciones
  const { showError } = useToast();

  /* ────────────────────────────────────────────────────────────────── */
  /*  Detectar sesión expirada mediante query param ?error=sessionExpired */
  /* ────────────────────────────────────────────────────────────────── */
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get('error') === 'sessionExpired') {
      showError('Sesión expirada. Por favor, inicia sesión nuevamente.');
    }
  }, [location.search, showError]);

  /* ────────────────────────────────────────────────────────────────── */
  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await login(username, password);
      navigate('/', {replace: true});
    } catch (error) {
      showError(error.message || 'Error de autenticación')
    }
  };
  /* ────────────────────────────────────────────────────────────────── */

  return (
    <div className="login-page">
      {/* Sección izquierda –––––––––––––––––––––––––––––––––––––––––– */}
      <section className="login-section">
        <article className="login-card" aria-labelledby="login-title">

        <h1 id="login-title">Iniciar sesión</h1>
        <form className="login-card" onSubmit={handleLogin} aria-label="Formulario de acceso">

          {/* <div class="input-group" style="margin-bottom: 1.25rem;"> */}
          <div className="input-group">
            <label htmlFor="username">Usuario</label>
            <div className="input-wrapper">
              <IconUser
                className="login-icons"
                role="img"
                aria-label="Formulario usuario"
              />
              <input
                type="text"
                id="username"
                name="username"
                placeholder="user"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>
          </div>


          {/* <div className="input-group" style="margin-bottom: 1.75rem;"> */}
          <div className="input-group password-form">
            <label htmlFor="password">Contraseña</label>
            <div className="input-wrapper">
              <IconLock
                className="login-icons"
                role="img"
                aria-label="Formulario password"
              />
              <input
                type="password"
                id="password"
                name="password"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required minLength="6" />
            </div>
          </div>

          <button type="submit" className="btn-submit">Acceder</button>
        </form>
        </article>
      </section>

      {/* Sección derecha ––––––––––––––––––––––––––––––––––––––––––– */}
      <aside className="brand-section" aria-label="Información de marca">
        <LogoPrincipal size={2}/>
        {/* <div className="words" aria-hidden="true">
          <span>Talento,</span>
          <span>Tecnología,</span>
          <span>Medios</span>
        </div> */}
      </aside>
    </div>
  );
};

export default LoginPage;
